define('services/analytics/analyticsChartFormatter',[
    'lib/knockout',
    'lib/lodash4',
    'moment',

    'extensions/i18n/knockout.i18n' // ensure that ko.i18n is loaded.
], function (ko, _, moment) {

    'use strict';

    var computeData = function (analyticsData, metricName, computationName) {
        var data = ko.unwrap(analyticsData);
        var metricStr = ko.unwrap(metricName);

        if (!data) {
            return 0;
        }

        return data[computationName](metricStr);
    };

    /**
     * Module that provides methods for formatting data in an AnalyticsData object for use
     * in a data visualizatoin.
     */
    var analyticsChartFormatter = {

        formatCount: function (analyticsData, metricName) {
            var sumCount = computeData(analyticsData, metricName, "sumCount");

            if (!sumCount) {
                return 0;
            }

            return sumCount;
        },

        formatAvg: function (analyticsData, metricName) {
            var avg = computeData(analyticsData, metricName, "avg");
            if (!avg) {
                return 0;
            }
            var duration = moment.duration(avg, "milliseconds");

            return (duration.asSeconds())/60;
        },

        formatPercentage: function (num) {
            if (_.isNull(num) || _.isUndefined(num)) {
                return 0;
            }

            return num;
        },

        formatSumTime: function (analyticsData, metricName) {
            var sum = computeData(analyticsData, metricName, "sum");
            if (!sum) {
                return 0;
            }

            var duration = moment.duration(sum, "milliseconds");

            return (duration.asSeconds())/60;
        }

    };

    return analyticsChartFormatter;

}); // end define()
;
